$(document).ready(function () {
    const $miCorpoBlogHomePageSelector = $('#mi-corpo-blog-home-page-selector');

    const allCategories = $miCorpoBlogHomePageSelector.find('option')
        .map(function () {
            return $(this).val().toLowerCase();
        })
        .get();

    const params = new URLSearchParams(window.location.search);
    let category = params.get('category');
    if ($miCorpoBlogHomePageSelector.find('option:selected').val() === '') {
        if (category) {
            category = Mi.Misc.Tools.convertDashToSpace(category); // eslint-disable-line no-undef
            if (allCategories.includes(category)) {
                history.replaceState({ category: category }, '', window.location.href);
                showResults(1, category);
            }
            else {
                $('#errorModal').modal('show');

                const url = new URL(window.location.href);
                url.searchParams.delete('category');
                history.replaceState({ category: '' }, '', url);
            }
        }
        else {
            // Set state for category 'All'
            history.replaceState({ category: '' }, '', window.location.href);
        }
    }

    $('.mi-corpo-blog-home-page-button').on('click', function () {
        showResults($(this).val(), $miCorpoBlogHomePageSelector.find('option:selected').val());
    });

    $miCorpoBlogHomePageSelector.on('change', function () {
        const selectedOption = $miCorpoBlogHomePageSelector
            .find('option:selected')
            .val();

        // Add category to URL
        const formattedCat = Mi.Misc.Tools.convertSpaceToDash(selectedOption); // eslint-disable-line no-undef
        const queryString = formattedCat ? `?category=${formattedCat}` : '';
        const newUrl = window.location.pathname + queryString;
        history.pushState({ category: formattedCat }, '', newUrl);

        showResults(1, selectedOption);
    });

    $('.mi-blog-article-body-tags-link').each(function () {
        var $this = $(this);
        var category = $this.attr('data-category');
        $this.click(function (e) {
            $miCorpoBlogHomePageSelector.val(category).change();
            e.preventDefault();
            return false;
        });
    });

    $('.mi-blog-category-tag-link').each(function () {
        var $this = $(this);
        var category = $this.attr('data-category');
        $this.click(function (e) {
            $miCorpoBlogHomePageSelector.val(category).change();
            e.preventDefault();
            return false;
        });
    });

    function showResults(page, category) {
        var queryString = '?pageNumber=' + page
                        + '&selectedCategory=' + category
                        + '&selectedItemId=' + $('#mi-corpo-blog-selectedItemId').val()
                        + '&postsPerPage=' + $('#mi-blog-posts-per-page').val();
        var requestManager = new AsyncRequestManager(); // eslint-disable-line no-undef
        requestManager.renderAsyncRequest('/bloghomepage/searchposts', queryString, '[data-widget="elcabloghomepage"]', true);
    }

    $(window).resize(function () {
        // This will fire each time the window is resized:
        if ($(window).width() >= 1024) {
            $('#mi-blog-categories-combo').hide();
            $('#mi-blog-categories-tag-list').show();
        }
        else {
            $('#mi-blog-categories-combo').show();
            $('#mi-blog-categories-tag-list').hide();
        }
    }).resize(); // This will simulate a resize to trigger the initial run.

    removeParamFromCanonical();

    $(window).on('popstate', function (event) {
        const state = event.originalEvent.state;

        if (!state) {
            return;
        }

        const category = state.category;
        showResults(1, category);
    });
});

function removeParamFromCanonical() {
    var url = location.protocol + '//' + location.host + location.pathname;
    $('link[rel=canonical]').attr('href', url);
}

